export enum BadgeVerificationStatus {
  NotVerified = 0,
  Verified = 1
}